import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const services = [
  {
    title: 'Baustellen-Content',
    desc: 'Echter Real-Life Content direkt von der Baustelle. Keine Filter, nur harte Arbeit.',
    icon: FiIcons.FiVideo
  },
  {
    title: 'Vorher/Nachher',
    desc: 'Beeindruckende Transformationen von Projekten, die handwerkliches Können beweisen.',
    icon: FiIcons.FiLayers
  },
  {
    title: 'Tool- & Materialtests',
    desc: 'Ehrliche, ungeschönte Tests von Werkzeugen und Materialien im harten Praxiseinsatz.',
    icon: FiIcons.FiTool
  },
  {
    title: 'Markenkooperationen',
    desc: 'Authentische Platzierung deiner Produkte in einem glaubwürdigen, professionellen Umfeld.',
    icon: FiIcons.FiBriefcase
  },
  {
    title: 'Social Media Reichweite',
    desc: 'Zugang zu einer engagierten Zielgruppe aus Handwerkern und Bau-Interessierten.',
    icon: FiIcons.FiTrendingUp
  }
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-zinc-900 relative border-y border-zinc-800">
      <div className="container mx-auto px-6 md:px-12">
        
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white mb-4"
          >
            Was ich <span className="text-orange-500">mache</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-zinc-400 max-w-2xl mx-auto"
          >
            Kein Bullshit, nur Resultate. Das ist mein Fokus auf der Baustelle und online.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-zinc-950 p-8 border border-zinc-800 hover:border-orange-500/50 transition-colors group relative overflow-hidden"
            >
              {/* Hover gradient effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              
              <div className="w-14 h-14 bg-zinc-900 border border-zinc-800 flex items-center justify-center mb-6 text-orange-500 group-hover:bg-orange-500 group-hover:text-zinc-950 transition-all rounded-sm">
                <SafeIcon icon={service.icon} className="w-6 h-6" />
              </div>
              
              <h3 className="text-xl font-bold text-white mb-3 uppercase tracking-wide">
                {service.title}
              </h3>
              
              <p className="text-zinc-400 text-sm leading-relaxed">
                {service.desc}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;